import { MasterState } from "~/redux/modules/master";
import { Question, QuestionText, Answer } from "~/types/question";
import {
  questionTextFormat,
  multipleFormat,
  isNextQuestionFormat,
  answerTypeFormat,
  categoriesFormat,
  answerFormat,
} from "../helpers/format";

type Column = {
  id: keyof Question;
  label: string;
  minWidth?: number;
  // eslint-disable-next-line no-unused-vars
  format?: (_: any) => string;
};

export const getColumns = (master: MasterState): Column[] => [
  {
    id: "categoryId",
    label: "カテゴリ",
    minWidth: 100,
    format: (val: number) => categoriesFormat(val, master),
  },
  {
    id: "largeLabel",
    label: "大項目",
    minWidth: 120,
  },
  {
    id: "mediumLabel",
    label: "中項目",
    minWidth: 120,
  },
  {
    id: "smallLabel",
    label: "小項目",
    minWidth: 120,
  },
  {
    id: "questionText",
    label: "質問文",
    minWidth: 500,
    format: (val: QuestionText[]) => questionTextFormat(val),
  },
  {
    id: "textAnswer",
    label: "回答方式",
    minWidth: 120,
    format: (val: boolean) => answerTypeFormat(val),
  },
  {
    id: "multiple",
    label: "複数回答",
    minWidth: 80,
    format: (val: boolean) => multipleFormat(val),
  },
  {
    id: "isNextQuestion",
    label: "新規の質問かどうか",
    minWidth: 140,
    format: (val: boolean) => isNextQuestionFormat(val),
  },
  {
    id: "answerOptions",
    label: "ユーザーの回答",
    minWidth: 200,
    format: (val: Answer[]) => answerFormat("text", val),
  },
  {
    id: "answerOptions",
    label: "回答に対するSHUZOの反応",
    minWidth: 400,
    format: (val: Answer[]) => answerFormat("reaction", val),
  },
];
